export default __webpack_public_path__ + "static/media/BB_21.5517c5fc.png";